import {Component, OnInit} from '@angular/core';
import {mergeMap, switchMap, tap} from "rxjs/operators";
import {from} from "rxjs";
import {Inspection} from "../../../classes/inspection";
import {Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {InspectionService} from "../../../services/inspection";
import {HttpErrorResponse} from "@angular/common/http";
import {PaService} from "../../../services/pa";
import {ContractService} from "../../../services/contract";
import {Pa} from "../../../classes/pa";
import {Contract} from "../../../classes/contract";

@Component({
    selector: 'app-inspection-create',
    templateUrl: './inspection-create.component.html',
    styleUrls: ['./inspection-create.component.css']
})
export class InspectionCreateComponent implements OnInit {

    inspection = new Inspection();
    pa = new Pa();
    inspectionCreationResult = true;

    pas: Array<Pa> = [];
    contracts: Array<Contract> = [];

    constructor(private router: Router,
                private modalService: NgbModal,
                private inspectionService: InspectionService,
                private paService: PaService,
                private contractService: ContractService) {
    }

    ngOnInit(): void {
        this.paService.getAll()
            .pipe(
                switchMap((pasData: any) => from(pasData))
            )
            .subscribe({
                next: (pa: any) => {
                    this.pas.push(pa);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });

        this.contractService.getAll()
            .pipe(
                switchMap((contractsData: any) => from(contractsData))
            )
            .subscribe({
                next: (contract: any) => {
                    this.contracts.push(contract);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });
    }

    onSubmit() {
        this.inspection.fk_id_inspection_state = 1;
        this.inspection.fk_id_user = undefined;
        this.inspection.date = undefined;

        if (this.pa.name !== "") {
            this.paService.upsert(this.pa)
                .pipe(
                    tap((pa: any) => this.inspection.fk_id_pa = pa.id_pa),
                    mergeMap(() => this.inspectionService.create(this.inspection))
                )
                .subscribe({
                    next: () => {
                        this.router.navigate(['/inspection']);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.inspectionCreationResult = false;
                        console.log(err);
                    }
                });
        } else {
            this.inspectionService.create(this.inspection)
                .subscribe({
                    next: (inspectionCreated: any) => {
                        this.router.navigate(['/inspection/' + inspectionCreated.id_inspection]);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.inspectionCreationResult = false;
                        console.log(err);
                    }
                });
        }
    }

}
